import Vue from 'vue'
import { meta } from '@App/Meta'

const MAX_LENGTH = 5
const LOCAL_STORAGE_KEY = 'teclia_recent_quick_replies_' + meta('user-id')

export let recentQuickReplies = Vue.observable({
    records: JSON.parse(readFromLocalStorage(LOCAL_STORAGE_KEY, '[]')),
})

export function add(quickReply) {
    recentQuickReplies.records = recentQuickReplies.records.filter(r => r.id != quickReply.id)
    recentQuickReplies.records.unshift(quickReply)

    if (recentQuickReplies.records.length > MAX_LENGTH) {
        recentQuickReplies.records.pop()
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(recentQuickReplies.records))
}

function readFromLocalStorage(key, defaultValue) {
    try {
        if (typeof window.localStorage !== 'undefined') {
            return localStorage.getItem(LOCAL_STORAGE_KEY) || defaultValue
        }
    } catch (err) {
        return defaultValue
    }

    return defaultValue
}
